document.addEventListener('DOMContentLoaded', function () {
  var posSelect = document.querySelector('#pos-select');
  if (!posSelect) return;

  var dynamicCheckout = document.querySelector('.additional-checkout-buttons');
  var form = document.querySelector('form.cart');

  function toggleDynamicCheckout() {
    if (dynamicCheckout) {
      dynamicCheckout.style.display = posSelect.value ? '' : 'none';
    }
  }

  posSelect.addEventListener('change', function (e) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { pos_product: e.target.value } })
    });
    toggleDynamicCheckout();
  });

  form.addEventListener('submit', function (e) {
    var clicked = e.submitter && e.submitter.name;
    if (clicked === 'checkout' && !posSelect.value) {
      e.preventDefault();
      posSelect.focus();
      posSelect.reportValidity();
    }
  });

  toggleDynamicCheckout();
});